import React from "react";

interface Props {
    title: string;
    badge?: string;
    lead?: string;
    image?: string;
    imageAlt?: string;
}

export const PageHero = (props: Props) => {
    return (
        <header className={props.image ? 'ttc-hero' : 'ttc-hero no-photo'}>
            <div className={'ttc-hero-copy'}>
                {props.badge && <span className={'ttc-badge'}>{props.badge}</span>}
                <h1 className={'ttc-headline'}>{props.title}</h1>
                {props.lead && <p className={'ttc-lead'}>{props.lead}</p>}
            </div>
            {props.image && (
                <div className={'ttc-hero-photo'}>
                    <img src={props.image} alt={props.imageAlt ?? props.title}/>
                </div>
            )}
        </header>
    )
}
